import React from "react";

// Compact sparkline (sentiment over time) for cards
export default function Sparkline({ values = [], width = 200, height = 40, color = "#FFCC00" }) {
  if (!values || values.length < 2) {
    return (
      <div className="h-10 flex items-center overline" data-testid="sparkline-empty">
        not enough data
      </div>
    );
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = Math.max(1e-6, max - min);
  const stepX = width / (values.length - 1);
  const points = values
    .map((v, i) => `${(i * stepX).toFixed(2)},${(height - ((v - min) / range) * height).toFixed(2)}`)
    .join(" ");
  const last = values[values.length - 1];
  const lastY = height - ((last - min) / range) * height;
  return (
    <svg width={width} height={height} data-testid="sparkline">
      <polyline points={points} fill="none" stroke={color} strokeWidth="1.5" />
      <circle cx={width} cy={lastY} r="2.5" fill={color} />
    </svg>
  );
}
